import { Group, Paper, Text } from "@mantine/core";
import IconGripVertical from "@tabler/icons-react/dist/esm/icons/IconGripVertical.mjs";

import {
  DRAG_DATA_FIELD,
  DRAG_ENTITY_FIELD,
  DRAG_ENTITY_SOURCE,
  DRAG_GROUP_BY,
  DRAG_ORDER_BY,
  DRAG_CONDITION_FIELD,
} from "./kinds";

/**
 * The element rendered inside <DragOverlay> while a drag is active.
 *
 * Returns null for unknown drag kinds — dnd-kit treats a null child as
 * "no overlay" and falls back to transforming the original draggable.
 * In our setup every draggable has a kind, so this branch is mostly
 * defensive.
 *
 * Important: this component MUST render an element with a real size,
 * because dnd-kit uses the overlay's bounding rect for collision
 * detection. An empty / zero-sized overlay silently breaks drops.
 */
export default function DragPreview({ active }) {
  if (!active?.data?.current) return null;
  const data = active.data.current;

  let label = null;
  if (data.kind === DRAG_ENTITY_FIELD) {
    label = data.entityField?.name ?? "Field";
  } else if (data.kind === DRAG_DATA_FIELD) {
    label =
      data.dataField?.entityField?.name ||
      data.dataField?.entityField?.field?.name ||
      "Data field";
  } else if (data.kind === DRAG_ORDER_BY) {
    label =
      data.orderByItem?.entityField?.name ||
      data.orderByItem?.entityField?.field?.name ||
      "Order by";
  } else if (data.kind === DRAG_GROUP_BY) {
    label =
      data.groupItem?.entityField?.name ||
      data.groupItem?.entityField?.field?.name ||
      "Group by";
  } else if (data.kind === DRAG_ENTITY_SOURCE) {
    label = data.entity?.name ?? "Entity";
  } else if (data.kind === DRAG_CONDITION_FIELD) {
    label =
      data.entityField?.name || data.entityField?.field?.name || "Field";
  }

  if (label == null) return null;

  return (
    <Paper
      withBorder
      shadow="md"
      px="sm"
      py="xs"
      radius="sm"
      style={{
        backgroundColor: "var(--mantine-color-gray-0)",
        cursor: "grabbing",
        width: "fit-content",
      }}
    >
      <Group gap={6} wrap="nowrap">
        <IconGripVertical size={14} stroke={1.5} />
        <Text size="sm">{label}</Text>
      </Group>
    </Paper>
  );
}
